import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  UPLOAD_NEWS_IMAGE_FAILURE,
  UPDATE_SWITCH_FUNCTION_WHITELIST_FAILURE,
  UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS,
  SWITCH_FUNCTION_SHOP_CHECKING_FAILURE,
  PREMIUM_SHOP_UNMERGE_SHOP_SUCCESS,
  PREMIUM_SHOP_UNMERGE_SHOP_FAILURE,
  PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_FAILURE,
  PREMIUM_SHOP_TRANSFER_PRIMARY_SUCCESS,
  PREMIUM_SHOP_TRANSFER_PRIMARY_FAILURE,
  PREMIUM_SHOP_DEACTIVATE_FAILURE,
  PREMIUM_SHOP_DEACTIVATE_SUCCESS,
  IMPORT_FOODY_MENU_INTO_OCHA_FAILURE,
  IMPORT_FOODY_MENU_INTO_OCHA_SUCCESS,
  NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_FAILURE,
  NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_SUCCESS,
  SHOP_OWNER_EXPIRE_SESSION_FAILURE,
  SHOP_OWNER_EXPIRE_SESSION_SUCCESS,
  SHOP_LOGIN_DISABLE_REVERT_SUCCESS,
  SHOP_LOGIN_DISABLE_REVERT_FAILURE,
  SHOP_DISABLE_REQUEST_OTP_SUCCESS,
  SHOP_DISABLE_REQUEST_OTP_FAILURE,
  SHOP_DISABLE_REQUEST_CONFIRM_SUCCESS,
  SHOP_DISABLE_REQUEST_CONFIRM_FAILURE,
  E_PAYMENT_UPDATE_SETUP_REQUEST_FAILURE,
  E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS,
  E_PAYMENT_GET_SERVICE_TERMINAL_ID_FAILURE,
  SHOP_UNBLOCK_INIT_REQUEST_SUCCESS,
  SHOP_UNBLOCK_INIT_REQUEST_FAILURE,
  SHOP_UNBLOCK_CONFIRM_REQUEST_SUCCESS,
  SHOP_UNBLOCK_CONFIRM_REQUEST_FAILURE,
  SHOP_UNBLOCK_FORCE_REQUEST_SUCCESS,
  SHOP_UNBLOCK_FORCE_REQUEST_FAILURE,
  EXTEND_MEMBERSHIP_UPDATE_SUCCESS,
  EXTEND_MEMBERSHIP_UPDATE_FAILURE,
  clearCrudResourceData,
  saveFilter,
} from 'actions';
import {
  nowOchaShopsFrontendPath,
  premiumShopFrontendPath,
  extendMembershipFrontendPath,
} from 'routes/advancedFunction/urls';
import {PremiumShopResourceName} from 'routes/advancedFunction/utils';
import { showNotification } from 'actions/notificationActions';
import { setSaving} from "../../actions";
import { loginFrontendPath } from 'routes/auth';
import { shopDisableFrontendPath, shopUnblockFrontendPath } from "routes/shop";
import { setupRequestFrontendPath } from "routes/e_payment";

/**
 * Side effects for fetch responses
 *
 * Mostly redirects and notifications
 */
function* handleResponse({ type, error, meta }) {
  switch (type) {
    case UPDATE_SWITCH_FUNCTION_WHITELIST_FAILURE:
    case SWITCH_FUNCTION_SHOP_CHECKING_FAILURE:
    case PREMIUM_SHOP_UNMERGE_SHOP_FAILURE:
    case PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_FAILURE:
    case PREMIUM_SHOP_DEACTIVATE_FAILURE:
    case PREMIUM_SHOP_TRANSFER_PRIMARY_FAILURE:
    case IMPORT_FOODY_MENU_INTO_OCHA_FAILURE:
    case NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_FAILURE:
    case SHOP_OWNER_EXPIRE_SESSION_FAILURE:
    case E_PAYMENT_UPDATE_SETUP_REQUEST_FAILURE:
    case E_PAYMENT_GET_SERVICE_TERMINAL_ID_FAILURE:
    case SHOP_DISABLE_REQUEST_OTP_FAILURE:
    case SHOP_DISABLE_REQUEST_CONFIRM_FAILURE:
    case SHOP_UNBLOCK_INIT_REQUEST_FAILURE:
    case SHOP_UNBLOCK_CONFIRM_REQUEST_FAILURE:
    case SHOP_UNBLOCK_FORCE_REQUEST_FAILURE:
    case EXTEND_MEMBERSHIP_UPDATE_FAILURE:
    case SHOP_LOGIN_DISABLE_REVERT_FAILURE:
    case UPLOAD_NEWS_IMAGE_FAILURE: {
      const errorMessage = typeof error === 'string'
        ? error
        : (error.message || 'HTTP Error');
      if (meta.httpStatus === 401) {
        return yield [
          put(showNotification(errorMessage, 'warning')),
          put(push(loginFrontendPath)),
        ];
      }
      return yield [
        put(showNotification(errorMessage, 'warning')),
        put(setSaving(false))
      ];
    }
    case UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS:
      return yield [
        put(showNotification('Update whitelist success!', 'success')),
      ];
    case EXTEND_MEMBERSHIP_UPDATE_SUCCESS:
      return yield [
        put(showNotification('Extend membership success', 'success')),
        put(push(extendMembershipFrontendPath)),
      ];
    case PREMIUM_SHOP_UNMERGE_SHOP_SUCCESS:
      return yield [
        put(showNotification('Unmerge shop success', 'success')),
        put(clearCrudResourceData(PremiumShopResourceName)),
        put(saveFilter(PremiumShopResourceName, undefined)),
        put(push(premiumShopFrontendPath)),
      ];
    case PREMIUM_SHOP_TRANSFER_PRIMARY_SUCCESS:
      return yield [
        put(showNotification('Transfer primary shop success', 'success')),
        put(clearCrudResourceData(PremiumShopResourceName)),
        put(saveFilter(PremiumShopResourceName, undefined)),
        put(push(premiumShopFrontendPath)),
      ];
    case PREMIUM_SHOP_DEACTIVATE_SUCCESS:
      return yield [
        put(showNotification('Deactivate shop success', 'success')),
        put(clearCrudResourceData(PremiumShopResourceName)),
        put(saveFilter(PremiumShopResourceName, undefined)),
        put(push(premiumShopFrontendPath)),
      ];
    case SHOP_DISABLE_REQUEST_CONFIRM_SUCCESS:
      return yield [
        put(showNotification('Disable shop success', 'success')),
        put(push(shopDisableFrontendPath)),
      ];
    case SHOP_UNBLOCK_CONFIRM_REQUEST_SUCCESS:
    case SHOP_UNBLOCK_FORCE_REQUEST_SUCCESS:
      return yield [
        put(showNotification('Enable shop success', 'success')),
        put(push(shopUnblockFrontendPath)),
      ];
    case IMPORT_FOODY_MENU_INTO_OCHA_SUCCESS:
      return yield [
        put(showNotification('Import Foody menu to Ocha success!', 'success')),
      ];
    case NOW_OCHA_CHANGE_DELIVERY_STATUS_REQUEST_SUCCESS:
      return yield [
        put(showNotification('Change status success', 'success')),
        put(push(nowOchaShopsFrontendPath)),
      ];
    case SHOP_OWNER_EXPIRE_SESSION_SUCCESS:
      return yield [
        put(showNotification('Expiry session success', 'success')),
      ];
    case SHOP_LOGIN_DISABLE_REVERT_SUCCESS:
      return yield [
        put(showNotification('Revert success', 'success')),
      ];
    case SHOP_DISABLE_REQUEST_OTP_SUCCESS:
    case SHOP_UNBLOCK_INIT_REQUEST_SUCCESS:
      return yield [
        put(showNotification('Send OTP verify success', 'success')),
      ];
    case E_PAYMENT_UPDATE_SETUP_REQUEST_SUCCESS:
      return yield [
        put(showNotification('Update setup request success', 'success')),
        put(push(setupRequestFrontendPath)),
      ];
    default:
      return yield [];
  }
}

export default function* () {
  yield takeEvery(action => action.meta && action.meta.customFetchResponse, handleResponse);
}



// WEBPACK FOOTER //
// ./src/sideEffect/saga/customResponse.js